import { render, staticRenderFns } from "./attributes-option-api-handler.vue?vue&type=template&id=66d7e1da&"
import script from "./attributes-option-api-handler.vue?vue&type=script&lang=js&"
export * from "./attributes-option-api-handler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports